<ng-select
  #projectSelect
  [fixNgSelectBottom]="projectSelect"
  data-cy="projectSelect"
  class="w-[180px] select-none text-base"
  (open)="openProjectSelect()"
  [loading]="projectsListLoading"
  [items]="projectsList"
  [clearable]="false"
  [searchable]="false"
  [disabled]="selectedOrgId === undefined || needSave === true"
  [(ngModel)]="selectedProjectId"
  (change)="projectChange()"
  (keyup.esc)="$event.stopImmediatePropagation(); projectSelect.blur()"
  (keyup.enter)="$event.stopImmediatePropagation(); projectSelect.blur()"
  appendTo="body"
  placeholder="Project"
  bindLabel="name"
  bindValue="projectId"
>
  <ng-template ng-label-tmp let-item="item">
    <div class="ml-1 truncate">{{ item.name }}</div>
  </ng-template>

  <ng-template ng-option-tmp let-item="item">
    <div class="ml-1 truncate">{{ item.name }}</div>
  </ng-template>

  <ng-template #templateNewProject>
    <div *ngIf="nav.orgName === demoOrgName"
      >Organization "Demo" is restricted</div
    >

    <div *ngIf="nav.orgName !== demoOrgName && user.userId !== nav.orgOwnerId"
      >Only organization owner can access</div
    >
  </ng-template>

  <ng-template ng-footer-tmp>
    <div
      [tp]="templateNewProject"
      placement="left"
      [tpIsEnabled]="
        user.userId !== nav.orgOwnerId || nav.orgName === demoOrgName
      "
    >
      <button
        data-cy="projectSelectCreateProjectButton"
        class="w-full rounded py-3 text-base focus:outline-none"
        [ngClass]="{
          'text-m600 hover:bg-m50':
            user.userId === nav.orgOwnerId && nav.orgName !== demoOrgName,
          'text-s400 cursor-default':
            user.userId !== nav.orgOwnerId || nav.orgName === demoOrgName
        }"
        (click)="createNewProject()"
        [disabled]="
          user.userId !== nav.orgOwnerId || nav.orgName === demoOrgName
        "
        >New Project</button
      >
    </div>
  </ng-template>
</ng-select>

<div *ngIf="selectedProject$ | async"></div>
<div *ngIf="selectedOrg$ | async"></div>
<div *ngIf="needSave$ | async"></div>
<div *ngIf="nav$ | async"></div>
<div *ngIf="user$ | async"></div>
